
        import * as module0 from './controllers/dropdown_controller.js';import * as module1 from './controllers/highlight_controller.js'
        const modules = {
            "./controllers/dropdown_controller.js": module0,
            "./controllers/highlight_controller.js": module1,
        };
        export default modules;
      